import { collection, deleteDoc, doc, getDocs, query, where } from "firebase/firestore";

const GUEST_COLLECTIONS = ["students", "teachers", "schedules", "finances", "visitLogs", "meetingMinutes", "attendanceLogs"];

function clearGuestLocalData(uid) {
    GUEST_COLLECTIONS.forEach((col) => localStorage.removeItem(`guest_${col}`));
    localStorage.removeItem("guest_budget");
    localStorage.removeItem("guest_budgets");
    localStorage.removeItem("guest_userProfile");
    localStorage.removeItem("guest_myDepartments");

    const dashboardKeys = ["dashboard_todos", "dashboard_layouts", "dashboard_widgets", "dashboard_banner_message", "dept_goals", "notifications"];
    dashboardKeys.forEach((key) => localStorage.removeItem(key));

    const userPrefixes = [
        "dashboard_radar_dismissed_",
        `attendance_${uid}_`,
        `chatHistory_${uid}`,
        `aaron_recent_prompts_${uid}`,
        `aaron_limit_date_${uid}`,
        `aaron_daily_count_${uid}`,
        `hasSeenTour_${uid}`
    ];

    Object.keys(localStorage).forEach((key) => {
        if (userPrefixes.some((prefix) => key.startsWith(prefix))) {
            localStorage.removeItem(key);
        }
    });
}

async function clearGuestFirestoreData(db, uid) {
    for (const collectionName of GUEST_COLLECTIONS) {
        const q = query(collection(db, collectionName), where("userId", "==", uid));
        const snapshot = await getDocs(q);
        await Promise.all(snapshot.docs.map((snapshotDoc) => deleteDoc(snapshotDoc.ref)));
    }

    await deleteDoc(doc(db, "settings", uid));
    await deleteDoc(doc(db, "users", uid));
}

export async function cleanupGuestData(db, uid) {
    try {
        clearGuestLocalData(uid);
        await clearGuestFirestoreData(db, uid);
    } catch (error) {
        console.error("Cleanup failed", error);
    }
}
